
import React, { useState, useEffect } from 'react';
import { WEDDING_DATE } from '../constants';
import { CountdownTime } from '../types';

const Countdown: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState<CountdownTime>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const difference = WEDDING_DATE.getTime() - now.getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      } else {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const TimeUnit = ({ value, label }: { value: number; label: string }) => (
    <div className="flex flex-col items-center flex-1">
      <span className="text-4xl xs:text-4xl sm:text-5xl font-serif font-light leading-none">
        {value.toString().padStart(2, '0')}
      </span>
      <span className="text-[8px] sm:text-[9px] uppercase tracking-[0.1em] mt-1 opacity-60">
        {label}
      </span>
    </div>
  );

  return (
    <div className="flex flex-nowrap items-center justify-between gap-1 py-4 text-white max-w-full overflow-hidden">
      <TimeUnit value={timeLeft.days} label="Días" />
      <div className="text-xl opacity-20 self-start mt-1">:</div>
      <TimeUnit value={timeLeft.hours} label="Horas" />
      <div className="text-xl opacity-20 self-start mt-1">:</div>
      <TimeUnit value={timeLeft.minutes} label="Min" />
      <div className="text-xl opacity-20 self-start mt-1">:</div>
      <TimeUnit value={timeLeft.seconds} label="Seg" />
    </div>
  );
};

export default Countdown;
